import * as React from 'react'

import { NextDialogProvider } from '../../../app/_components/dialogs/NextDialog.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../containers/EmbroideryService'
import { EmbroideryModalService } from '../../../containers/EmbroideryService/EmbroideryModalService'
import { EmbroideryModalPreview } from '../EmbroideryModalPreview'

import { EmbroideryModalHeader } from './EmbroideryModalHeader'
import { ModalEmbroideryOptions } from './EmbroideryOptionSelector/EmbroideryOptionSelector'
import * as Styles from './styles'

export const EmbroideryModal: React.FC<{
  heapCtaAction?: string
}> = ({ heapCtaAction }) => {
  const {
    embroidery: { modal: strings, embroideryOptionTitles, close },
  } = useTranslation()
  const {
    currentlySelectedFormOption,
    setPreviewItemsByKind,
    setSelectedFormKind,
    selectedEmbroideryOptions,
    selectedFormKind,
  } = EmbroideryService.useContainer()

  const { shouldDisplayEmbroideryModal, closeEmbroideryModal, triggerElement } =
    EmbroideryModalService.useContainer()

  const closeBtnRef = React.useRef<HTMLButtonElement>(null)

  const headerTitle = currentlySelectedFormOption
    ? embroideryOptionTitles[currentlySelectedFormOption?.kind]
    : strings.title

  const handleBackButtonClick = () => {
    if (typeof selectedFormKind === 'string' && !selectedEmbroideryOptions[selectedFormKind]) {
      setPreviewItemsByKind(prev => ({
        ...prev,
        [selectedFormKind]: [],
      }))
    }
    setSelectedFormKind(null)
  }

  return (
    <NextDialogProvider open={shouldDisplayEmbroideryModal}>
      <Styles.Dialog
        backdrop={Styles.Backdrop}
        backdropTiming={Styles.BACKDROP_TIMING}
        dialogTiming={Styles.DIALOG_TIMING}
        finalFocus={triggerElement ?? undefined}
        onClose={closeEmbroideryModal}
      >
        <Styles.DialogBody>
          <EmbroideryModalHeader.Wrapper>
            <EmbroideryModalHeader.Section>
              {selectedFormKind !== null ? (
                <EmbroideryModalHeader.BackButton handleClick={handleBackButtonClick} />
              ) : null}
              <EmbroideryModalHeader.CloseButtonDesktop
                onClick={closeEmbroideryModal}
                ref={closeBtnRef}
                text={close}
                autoFocus
              />
            </EmbroideryModalHeader.Section>
            <EmbroideryModalHeader.Title>{headerTitle}</EmbroideryModalHeader.Title>
            <EmbroideryModalHeader.Section>
              <EmbroideryModalHeader.CloseButtonMobile
                onClick={closeEmbroideryModal}
                ref={closeBtnRef}
              />
            </EmbroideryModalHeader.Section>
          </EmbroideryModalHeader.Wrapper>
          <Styles.Container>
            <Styles.Section>
              <Styles.ImageHeader>
                <Styles.Title>{strings.previewTitle}</Styles.Title>
                <Styles.Subtitle>{strings.previewSubtitle}</Styles.Subtitle>
              </Styles.ImageHeader>
              <Styles.ImagePreviewWrap>
                <EmbroideryModalPreview />
              </Styles.ImagePreviewWrap>
            </Styles.Section>
            <Styles.Section>
              <ModalEmbroideryOptions
                heapCtaAction={heapCtaAction}
                handleBackButtonClick={handleBackButtonClick}
              />
            </Styles.Section>
          </Styles.Container>
        </Styles.DialogBody>
      </Styles.Dialog>
    </NextDialogProvider>
  )
}
